import React from 'react';
export const EmptyFolderGreyed = () => (
  <svg width="84px" height="111px" viewBox="0 0 84 111" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-281.000000, -2079.000000)">
        <g transform="translate(282.000000, 2080.000000)">
          <path
            d="M33.1407,0.1449 L33.1407,2.5269"
            stroke="#C3D3D8"
            strokeLinecap="round"
          />
          <path
            d="M33.1407,7.2904 L33.1407,9.6724"
            stroke="#C3D3D8"
            strokeLinecap="round"
          />
          <path
            d="M37.9043,4.9086 L35.5223,4.9086"
            stroke="#C3D3D8"
            strokeLinecap="round"
          />
          <path
            d="M30.7588,4.9086 L28.3768,4.9086"
            stroke="#C3D3D8"
            strokeLinecap="round"
          />
          <path
            d="M77.2207,18.2152 L77.2207,20.5972"
            stroke="#C3D3D8"
            strokeLinecap="round"
          />
          <path
            d="M77.2207,25.3608 L77.2207,27.7428"
            stroke="#C3D3D8"
            strokeLinecap="round"
          />
          <path
            d="M81.9849,22.9789 L79.6029,22.9789"
            stroke="#C3D3D8"
            strokeLinecap="round"
          />
          <path
            d="M74.8389,22.9789 L72.4569,22.9789"
            stroke="#C3D3D8"
            strokeLinecap="round"
          />
          <path
            d="M47.9981,16.8178 C47.9981,17.8158 47.1891,18.6258 46.1901,18.6258 C45.1921,18.6258 44.3831,17.8158 44.3831,16.8178 C44.3831,15.8198 45.1921,15.0098 46.1901,15.0098 C47.1891,15.0098 47.9981,15.8198 47.9981,16.8178 Z"
            stroke="#C3D3D8"
          />
          <path
            d="M16.2954,63.4418 L14.8924,63.9698"
            stroke="#A3BEC6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polyline
            stroke="#A3BEC6"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="13.1338 64.6322 11.7298 65.1602 11.2018 63.7562"
          />
          <path
            d="M9.2886,58.6723 L1.6356,38.3363"
            stroke="#A3BEC6"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="2.716,5.432"
          />
          <polyline
            stroke="#A3BEC6"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="0.6783 35.7944 0.1503 34.3904 1.5543 33.8614"
          />
          <path
            d="M6.4629,32.0151 L18.7349,27.3961"
            stroke="#A3BEC6"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="2.623,5.245"
          />
          <polyline
            stroke="#A3BEC6"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="21.19 26.4721 22.594 25.9441 23.122 27.3481"
          />
          <path
            d="M25.5376,33.768 L26.0656,35.171"
            stroke="#A3BEC6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polygon
            fill="#F3F4F6"
            points="76.4375 73.142 26.4525 81.724 22.0625 43.071 39.4485 40.085 39.9085 43.134 71.8345 37.653"
          />
          <polygon
            stroke="#C3D3D8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="76.4375 73.142 26.4525 81.724 22.0625 43.071 39.4485 40.085 39.9085 43.134 71.8345 37.653"
          />
          <g transform="translate(17.000000, 42.710000)">
            <polyline
              fill="#FCFCFC"
              points="3.2471 18.1801 0.6511 9.4641 52.2991 0.5961 59.4371 30.4321 9.4521 39.0141 4.7061 23.0781"
            />
            <polyline
              stroke="#C3D3D8"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="3.2471 18.1801 0.6511 9.4641 52.2991 0.5961 59.4371 30.4321 9.4521 39.0141 4.7061 23.0781"
            />
          </g>
          <path
            d="M66.4405,104.4926 C66.4405,107.1186 58.9835,109.2476 49.7845,109.2476 C40.5855,109.2476 33.1275,107.1186 33.1275,104.4926 C33.1275,101.8656 40.5855,99.7366 49.7845,99.7366 C58.9835,99.7366 66.4405,101.8656 66.4405,104.4926"
            fill="#F3F4F6"
          />
        </g>
      </g>
    </g>
  </svg>
);
